import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ProgramDto, ProgramFundingListItemDto, PlanData, RetailerLookupDto, StrategicBusinessInitiativeLookupDto, BrandLookupDto, BudgetYearLookupDto, SaveProgramCommand, ProgramId } from 'app/client-core/dtos/programs.model';
import { RetailerService } from 'app/client-core/services/retailer.service';
import { ProgramService } from 'app/client-core/services/program.service';
import { Observable } from 'rxjs';
import { ValidationMessage } from 'app/validation';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { ApiResponse } from 'app/client-core/api-response-models';
import { Router } from '@angular/router';
import { BudgetYearTypeaheadComponent, StrategicBusinessInitiativesTypeaheadComponent, RetailersTypeaheadComponent } from '../typeahead';
import { BasicTypeaheadComponent } from '../typeahead/typeaheads/tactics/basic-typeahead.component';
import { CampaignThemeDto } from 'app/client-core/dtos/campaigns.model';
import { CampaignService } from 'app/client-core/services/campaign.service';
import { LayoutService } from '../layout/layout.service';
import { UserService } from 'app/client-core/services/user.service';
import { CierantTypeaheadComponent } from '../components/cierant-typeahead/cierant-typeahead.component';
import { ClientSettingsService } from 'app/client-core/services/client-settings.service';
import { JobsToBeDoneDetailsComponent } from '../components/jobs-to-be-done-details/jobs-to-be-done-details.component';
import { FundingSourceDetailsResult, Participant } from 'app/client-core/dtos/funding-details-dto.model';
import { MoneyFormatterPipe } from '../pipes/money-formatter.pipe';
import { FoundingSource } from 'app/client-core/dtos/funding-source.model';
import { TacticService } from 'app/client-core/services/tactic.service';
import { NotificationService } from '../utils/notification.service';

@Component({
  selector: 'app-funding-sources-modal',
  templateUrl: './funding-sources-modal.component.html',
  styleUrls: ['./funding-sources-modal.component.scss']
})
export class FundingSourcesModalComponent implements OnInit, OnChanges {
  @ViewChild('budgetYearTypeahead') budgetYearTypeahead: CierantTypeaheadComponent;
  @ViewChild('retailerTypeahead') retailerTypeahead: CierantTypeaheadComponent;
  @ViewChild('jobsToBeDone') jobsToBeDone: JobsToBeDoneDetailsComponent;

  activeTab = 'setup';
  ready = true;
  programDto: ProgramDto = {} as ProgramDto;
  submitted: boolean;
  @Input() hideStoreSelector = false;
  itemObjectsLeft: ProgramFundingListItemDto[] = [];
  showRetailerTooltip: boolean;
  showBudgetTooltip: boolean;
  @Input() fromMyCampaigns: boolean;
  @Input() fromProgramOverview: boolean;
  @Input() copy: boolean;
  @Input() programId: number;
  moneyFormatter: MoneyFormatterPipe;

  hoveringRetailerTooltip: boolean;
  hoveringBudgetTooltip: boolean;

  extraQueryParams = {};
  stores: Array<any> = [];
  shouldShowStoreField = false;
  allBrands: PlanData[] = [];
  allBrandsSelected: PlanData[] = [];
  retailer: any;
  showCreateCampaignInfoSubscription: any;
  campaignDto: CampaignThemeDto;
  brandFilter: string;
  campaignLoaded: boolean;
  showJobsToBedone: boolean;
  programFundingDetails: FundingSourceDetailsResult;
  uniPrismUpgrade: boolean;
  saving: boolean;
  canShowJobsToBeDone: boolean;

  moveToSelected(item: ProgramFundingListItemDto) {
    item.markedForDeletion = false;
    this.itemObjectsLeft = [...this.itemObjectsLeft.filter(my => my.jobsToBeDoneHeaderId != item.jobsToBeDoneHeaderId)];
    const index = this.programDto.programFunding.findIndex((my) => {
      return my.jobsToBeDoneHeaderId == item.jobsToBeDoneHeaderId
    });

    if (index == -1) {
      this.programDto.programFunding.push(item);
      this.programDto.programFunding = [...this.programDto.programFunding];
    } else {
      this.programDto.programFunding[index].markedForDeletion = false;
    }
  }

  moveToUnselected(item: ProgramFundingListItemDto) {
    item.markedForDeletion = true;
    this.programDto.programFunding = [...this.programDto.programFunding];

    const index = this.itemObjectsLeft.findIndex((my) => {
      return my.jobsToBeDoneHeaderId == item.jobsToBeDoneHeaderId
    });

    if (index == -1) {
      this.itemObjectsLeft.push(item);
      this.itemObjectsLeft = [...this.itemObjectsLeft];
    }
  }

  selectBrand(brand: PlanData, atl?: number, btl?: number) {
    if (!this.allBrands || this.allBrands.length == 0) {
      return;
    }
    this.allBrands.find(b => b.brandId == brand.brandId).selected = true;
    if (!this.allBrandsSelected.find(b => b.brandId == brand.brandId)) {
      this.allBrandsSelected.push({
        ...brand,
        selected: true,
        atlTarget: atl,
        btlTarget: btl
      });
    } else {
      this.allBrandsSelected.find(b => b.brandId == brand.brandId).selected = true;
    }
    // this.loadDetails();
    console.log(this.allBrandsSelected)
  }

  selectBrandClicked(brand: PlanData, atl?: number, btl?: number) {
    this.saveProgramFunding(brand);
    this.selectBrand(brand, atl, btl);
  }

  getSelectedFundingSources() {
    if (!this.programFundingDetails.programFundingSources) {
      return [];
    }

    return this.programFundingDetails.programFundingSources.filter(f => f.selected);
  }

  saveProgramFunding(brand) {
    if (!this.allBrands || this.allBrands.length == 0) {
      return;
    }
    var b = this.allBrands.find(b => b.brandId == brand.brandId);
    this.programService.addFundingSource(this.selectedProgramId, b).subscribe(res => {
      this.loadFundingSourceDetails();
    });
  }

  removeProgramFunding(fundingId, brand) {
    this.programService.removeFundingSource(fundingId).subscribe(res => {
      this.loadFundingSourceDetails();
      this.unselectBrand(brand);
    }, error => {
      this.validationMessages = new ValidationMessage(null, true, "Can't delete program funding").isDanger();
    });
  }

  unselectBrand(brand: PlanData) {
    if (!this.allBrands || this.allBrands.length == 0) {
      return;
    }
    this.allBrandsSelected = this.allBrandsSelected.filter(b => b.brandId != brand.brandId);
    this.allBrandsSelected.push({
      ...brand,
      selected: false
    });
    this.allBrands = this.allBrands.filter(b => b.brandId != brand.brandId);
    this.allBrands.push({
      ...brand,
      selected: false
    });

    if(this.programFundingDetails.programFundingSources.find(f => f.brandId == brand.brandId))
      this.programFundingDetails.programFundingSources.find(f => f.brandId == brand.brandId).selected = false;
    // this.loadDetails();
  }

  unselectBrandClicked(brand: PlanData, fundingId, name) {
    this.notificationService.smartMessageBox({
      title: "",
      content: `Are you sure you want to delete the funding source, ${name}, from this program?`,
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
        if (ButtonPressed == "Yes") {
          this.removeProgramFunding(fundingId, brand);
        }
    });
  }

  getBrandToUnselect(brandId) {
    if (!this.allBrands) {
      return null;
    }
    return this.allBrands.find(b => b.brandId == brandId)
  }

  leftBrands() {
    if (!this.brandFilter) {
      return this.allBrands.filter(b => !b.selected)
    }
    if (this.brandFilter) {
      return this.allBrands.filter(b => !b.selected && b.brandName.toLocaleLowerCase().indexOf(this.brandFilter.toLocaleLowerCase()) > -1); 
    } else {
      return this.allBrands.filter(b => !b.selected);
    }
  }

  rightBrands() {
    return this.allBrandsSelected.filter(b => b.selected)
  }

  getDate(val: any): Date {
    if (!val)
      return null;

    return new Date(val);
  }

  //this is assigned by the opener if it is an edit
  @Input() selectedCampaignId?: number;

  @Input()
  selectedProgramId?: number;

  @Input()
  retailerId: number;

  @Input()
  retailerName: string;

  @Input()
  budgetYear: number;

  @Input()
  goToProgramDetails: boolean;

  retailers: Observable<Array<RetailerLookupDto>>;
  strategicBusinessInitiatives: Observable<Array<StrategicBusinessInitiativeLookupDto>>;
  brands: Array<BrandLookupDto>;
  budgetYears: Observable<Array<BudgetYearLookupDto>>;
  filter: string;

  public validationMessages: ValidationMessage;

  isValid: boolean = false;

  onAfterValidate(isValid: boolean): void {
    console.log('>>IsValid', isValid);
    if (!isValid)
      return;

    this.onSubmit();
  }

  validatorOptions = {
    //container: '#messages',
    message: "Field is invalid",
    feedbackIcons: {
      valid: 'fa fa-check',
      invalid: 'fa fa-times',
      validating: 'fa fa-refresh'
    },
    fields: {

    }
  };

  @ViewChild('strategicBusiness') strategicBusiness: StrategicBusinessInitiativesTypeaheadComponent;
  @ViewChild('storeTypeahead') storeTypeahead: BasicTypeaheadComponent;
  retailerextraQueryParams = {};

  columns = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "retailerName", name: "Name", flexGrow: 3 },
  ]);

  columnsStore = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "name", name: "Name", flexGrow: 3 },
  ]);

  columnsFiscalYear = Observable.of([
    { prop: "fiscalYear", name: "Fiscal Year", flexGrow: 3 },
  ]);

  columnsBusinnesInitiative = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "name", name: "Name", flexGrow: 3 },
  ]);

  items: Array<any> = [];

  constructor(
    private layoutService: LayoutService,
    private programService: ProgramService,
    private retailerService: RetailerService,
    private router: Router,
    private campaignService: CampaignService,
    public userService: UserService,
    private clientSettingsService: ClientSettingsService,
    private tactiService: TacticService,
    private clientSettings: ClientSettingsService,
    private notificationService: NotificationService
  ) {
    this.moneyFormatter = new MoneyFormatterPipe();
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.programDto = {} as ProgramDto;
      this.retailer = null;
      this.budgetYear = null;
      this.stores = [];
      this.allBrandsSelected = [];
      this.programDto = new ProgramDto();
      this.shouldShowStoreField = false;
      this.allBrands = [];
      this.campaignLoaded = false;
      this.programDto.retailerId = null;
      this.programDto.retailerName = "";
      this.programDto.fiscalYear = null;
      CierantTypeaheadComponent.clearTextEvent.next("budgetTypeahead");
      CierantTypeaheadComponent.clearTextEvent.next("retailerTypeahead");
      if (this.strategicBusiness) {
        this.strategicBusiness.clearText();
      }
      if (this.retailerTypeahead) {
        this.retailerTypeahead.clearText();
      }
      if (this.storeTypeahead) {
        this.storeTypeahead.clearText();
      }
      this.campaignDto = null;
      this.programDto = new ProgramDto();
      this.selectedCampaignId = null;
      this.selectedProgramId = null;
      this.loadCampaignTheme();
      this.loadProgram();
      resolve();
    })
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadBrands();
    this.loadFundingSourceDetails();
    this.loadProgram();
    this.checkUniPrismUpgrade();
  }

  closeModal() {
    location.reload();
    // this.clear();
    // this.layoutService.hideSideModal.next();
  }

  onRetailersTypeaheadSelected($event: TypeaheadMatch): void {
    if ($event && $event.item.retailerId) {
      this.programDto.retailerId = +$event.item.retailerId;
      this.extraQueryParams = {
        retailerId: this.programDto.retailerId
      }
      this.retailerService.getAccountLocations({
        retailerId: this.programDto.retailerId
      }).subscribe(response => {
        if (!response.hasError) {
          if (response.data && response.data.items && response.data.items.length > 0) {
            this.shouldShowStoreField = true;
          } else {
            this.shouldShowStoreField = false;
          }
        }
      });
    }

    this.loadBrands();
    console.log('<<added program retailer', this.programDto.retailerId);
  }

  loadFundingSourceDetails(programId?) {
    this.programService.getProgramFundingDetails(programId || this.selectedProgramId).subscribe(res => {
      this.programFundingDetails = res.data;
      if (this.programFundingDetails && res.data.programFundingSources) {
        this.programFundingDetails.programFundingSources = res.data.programFundingSources.map(d => {
          return {
            ...d,
            selected: true
          }
        });
        this.updateSelectedBrands();
        this.loadDetails();
      }
    });
  }

  updateSelectedBrands() {
    if (!this.allBrands || this.allBrands.length == 0) {
      return;
    }
    this.allBrands.forEach(b => {
      if (this.programFundingDetails.programFundingSources.findIndex(f => f.brandId == b.brandId) > -1) {
        this.selectBrand(b);
      } else {
        this.unselectBrand(b);
      }
    });
  }

  onStrategicBusinessInitiativesTypeaheadSelected(event): void {
    if (event && event.id)
      this.programDto.strategicBusinessInitiativeId = event.id;
  }

  onBudgetYearTypeaheadSelected(event): void {
    if (event && event.fiscalYear) {
      this.programDto.fiscalYear = event.fiscalYear;
      this.retailerextraQueryParams = {
        budgetYear: event.fiscalYear,
        callType: 2
      }
    }
    this.loadBrands();
  }

  changeTheme() {
    if (this.selectedProgramId) {
      this.router.navigateByUrl(`/campaign-library/${this.selectedProgramId}`);
    }
  }

  loadBrands(retailer?, budgetYear?): void {
    this.retailerService.getRetailerBudgetYearBrands(retailer || this.retailerId, budgetYear || this.budgetYear, {})
      .subscribe(res => {
        if (!res.hasError) {
          this.allBrands = res.data;
          this.filterBrands();
          this.updateSelectedBrands();
          this.ready = true;
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Brands could not be retrieved");
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
        },
        () => {
        });
  }

  checkUniPrismUpgrade(budgetYear?) {
    this.clientSettingsService.getClientSettings().subscribe(res => {
      if (res.data.findIndex(c => c.name == "ClientSkin" && c.value == "Unilever") > -1 && (budgetYear || this.budgetYear) >= 2021) {
        this.uniPrismUpgrade = true; 
      }
    });
}

  filterBrands() {
    if (this.programDto.programFunding) {
      this.programDto.fundingSources.forEach(item => {
        const selectedBrand = this.allBrands.find(b => b.jobsToBeDoneHeaderId == item.jobsToBeDoneHeaderId);
        if (selectedBrand) {
          this.selectBrand(selectedBrand, item.estimatedAtl, item.estimatedBtl);
        }
      })
    }
  }

  loadProgram(programId?): void {
    console.log('>>loadProgram', this.selectedProgramId);

    if (!this.selectedProgramId) {
      this.ready = true;
      return;
    }

    this.programService.getProgram(programId || this.selectedProgramId)
      .subscribe(res => {
        if (!res.hasError) {
          this.programDto = ProgramDto.fixDates(res.data);
          this.loadCampaignTheme(this.programDto.campaignThemeId);
          if (this.programDto.fiscalYear == null) {
            var date = new Date();
            this.programDto.fiscalYear = new Date().getFullYear();
          }

          if (this.programDto.retailerId && this.programDto.fiscalYear) {
            this.loadBrands();
          }

          if (this.programDto.campaignThemeTypeId == 3) {
            this.hideStoreSelector = true;
          }

          this.extraQueryParams = {
            retailerId: this.programDto.retailerId
          }

          this.programService.getAccountLocations(this.programDto.id).subscribe(resp => {
            if (resp.data) {
              this.stores = resp.data.data;
              if (this.stores && this.stores.length > 0) {
                this.shouldShowStoreField = true;
              }
            }
            this.ready = true;
          });
          if (this.copy) {
            this.programDto.name = 'Copy of - ' + this.programDto.name;
          }

          this.selectedCampaignId = this.programDto.campaignThemeId;
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Program could not be retrieved");
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
        },
        () => {
        });
  }

  loadCampaignTheme(campaignThemeId?) {
    if (!this.selectedCampaignId && !campaignThemeId) {
      this.ready = true;
      this.campaignLoaded = true;
      return;
    }
    this.campaignService.getCampaignTheme(this.selectedCampaignId || campaignThemeId).subscribe(res => {
      if (!res.hasError) {
        this.campaignDto = res.data;
      }
      this.campaignLoaded = true;
    })
  }

  onSubmit(): void {
    var fundingSources: Array<FoundingSource> = [];

    if (this.programFundingDetails) {
      this.programFundingDetails
      .programFundingSources
      .filter(j => j.selected)
      .forEach(j => {
        if (j.fundings) {
          j.fundings.forEach(f => {
            fundingSources.push({
              allocationType: f.allocationType,
              fundingId: j.id,
              programFunding: f.programFunding,
              jtbdRevisionId: f.jtbdRevisionId,
              id: f.id,
            } as FoundingSource);
          }); 
        }
      });
    }

    var participants: Array<Participant> = [];
    this.programFundingDetails
      .programFundingSources
      .filter(j => j.selected)
      .forEach(j => {
        j.participants.forEach(f => {
          participants.push({
            isParticipatingBrand: f.isParticipatingBrand,
            isParticipatingBrandStatus: f.isParticipatingBrandStatus,
            jobsToBeDoneHeaderID: f.jobsToBeDoneHeaderID,
            participatingBrand: f.participatingBrand,
            participatingBrandId: f.participatingBrandId,
            programFundingId: f.programFundingId
          } as Participant);
        });
      });

    this.saving = true;
    this.programService.saveFundingSourcesEdit(fundingSources, participants).subscribe(res => {
      if (this.canShowJobsToBeDone) {
        this.jobsToBeDone.save(this.selectedProgramId).then(res => {
          this.tactiService.programTacticEdited.next();
          this.closeModal();
        }).catch(err => {
  
        });
      } else {
        this.tactiService.programTacticEdited.next();
        this.closeModal();
      }
    })
  }

  isRetailersNameValid() {
    return this.programDto.retailerId != null && this.programDto.retailerId !== undefined;
  }

  isProgramNameValid() {
    return this.programDto.name !== '' && this.programDto.name != null;
  }

  isProgramStartDateValid() {
    return this.programDto.programStartDate !== null && this.programDto.programStartDate !== undefined;
  }

  isDescriptionValid() {
    if (!this.programDto.description) return false;
    return true;
  }

  isProgramEndDateValid() {
    return this.programDto.programEndDate !== null && this.programDto.programEndDate !== undefined;
  }

  isBusinessDriverValid() {
    return this.programDto.strategicBusinessInitiativeId != null && this.programDto.strategicBusinessInitiativeId !== undefined;
  }

  isFiscalYearValid() {
    return this.programDto.fiscalYear != null && this.programDto.fiscalYear !== undefined;
  }

  canSubmit() {
    return this.isFiscalYearValid() &&
      this.isProgramNameValid() &&
      this.isProgramEndDateValid() &&
      this.isProgramStartDateValid() &&
      this.isStoreValid() &&
      this.isFundingSourceValid() &&
      this.isDescriptionValid();
  }

  isStoreValid() {
    if (!this.shouldShowStoreField) {
      return true;
    }
    if (!this.stores || this.stores.length == 0) {
      return false;
    }
    return true;
  }

  canShowBudgetTooltip() {
    return this.hoveringBudgetTooltip && this.programDto.hasProgramTactics;
  }

  onStoreSelected(store) {
    this.stores = [
      store
    ];
  }

  removeStore(store) {
    this.stores = [];
  }

  sumTotal(item: PlanData) {
    var atl = 0;
    var btl = 0;

    if (item.atlTarget) {
      atl = Number.parseFloat(item.atlTarget.toString().replace(',', ''));
    }

    if (item.btlTarget) {
      btl = Number.parseFloat(item.btlTarget.toString().replace(',', ''));
    }

    return atl + btl;
  }

  sumPrePlan(item: PlanData) {
    var atl = 0;
    var btl = 0;
    if (this.fromProgramOverview) {
      if (item.atlUnplanned) {
        atl = Number.parseFloat(item.atlUnplanned.toString().replace(',', ''));
      }

      if (item.btlUnplanned) {
        btl = Number.parseFloat(item.btlUnplanned.toString().replace(',', ''));
      }
    } else {
      if (item.atlPrePlanRemaining) {
        atl = Number.parseFloat(item.atlPrePlanRemaining.toString().replace(',', ''));
      }

      if (item.btlPrePlanRemaining) {
        btl = Number.parseFloat(item.btlPrePlanRemaining.toString().replace(',', ''));
      }
    }
    return atl + btl;
  }

  onRetailerRowSelected(row) {
    if (row && row.id) {
      this.programDto.retailerId = row.id;
      this.extraQueryParams = {
        retailerId: row.id
      }
      this.retailerId = row.id;
      this.retailerService.getAccountLocations({
        retailerId: this.programDto.retailerId
      }).subscribe(response => {
        if (!response.hasError) {
          if (response.data && response.data.items && response.data.items.length > 0) {
            this.shouldShowStoreField = true;
          } else {
            this.shouldShowStoreField = false;
          }
        }
      });
    }

    this.loadBrands();
    console.log('<<added program retailer', this.programDto.retailerId);
  }

  goToSelectCampaign() {
    this.router.navigateByUrl(`/campaign-library/${this.selectedProgramId}`);
  }

  revise() {
    this.programService.revise(this.selectedProgramId).subscribe(resp => {
      if (!resp.error) {
        this.validationMessages = new ValidationMessage(null, true, "Program revised");
        this.loadProgram();
        this.programService.programUpdated.next();
        this.campaignService.notify.next(this.selectedProgramId);
      }
    });
  }

  getPlaceHolder() {
    if (this.fromProgramOverview) {
      return this.retailerName;
    }
    if (this.programDto || this.retailer) {
      if (!this.goToProgramDetails) {
        return this.programDto.retailerName || 'Select Retailer';
      } else {
        return this.retailer.name || 'Select Retailer'
      }
    }
    return 'Select Retailer';
  }

  getFiscalYearPlaceHolder() {
    if (this.fromProgramOverview) {
      return this.budgetYear;
    }

    if (this.programDto.fiscalYear || this.budgetYear) {
      if (!this.goToProgramDetails) {
        return this.programDto.fiscalYear;
      } else {
        return this.budgetYear;
      }
    }
    return 'Select Budget Year';
  }

  isFundingSourceValid() {
    return this.programFundingDetails && this.programFundingDetails.programFundingSources && this.programFundingDetails.programFundingSources.length > 0;
  }

  getFundingHeaderIds() {
    if (this.isFundingSourceValid()) {
      return this.programFundingDetails.programFundingSources.map(f => f.jobsToBeDoneHeaderId).join(",");
    }
    return '';
  }

  getAvailableBudget(brandId, allocationType) {
    var brand = this.allBrands.find(b => b.brandId == brandId);
    if (!brand) {
      return '';
    }
    return `Available ${allocationType == 1 ? 'ATL' : 'BTL'} Budget: ` + this.moneyFormatter.transform(allocationType == 1 ? brand.atlPrePlanRemaining : brand.btlPrePlanRemaining, true);
  }

  loadDetails() {
    this.programService.getJobsToBeDoneDetails(this.getFundingHeaderIds(), this.selectedProgramId).subscribe(res => {
      this.canShowJobsToBeDone = res.data.canShow == 1;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/funding-sources-modal/funding-sources-modal.component.ts